import { FLYER_FONTS, type FlyerFontId } from '@pulsify/fonts'
import bebasUrl from '@pulsify/fonts/files/BebasNeue.ttf'
import interUrl from '@pulsify/fonts/files/Inter.ttf'
import montserratUrl from '@pulsify/fonts/files/Montserrat.ttf'
import oswaldUrl from '@pulsify/fonts/files/Oswald.ttf'
import playfairUrl from '@pulsify/fonts/files/PlayfairDisplay.ttf'

const FILE_URLS: Record<FlyerFontId, string> = {
  inter: interUrl,
  montserrat: montserratUrl,
  oswald: oswaldUrl,
  playfair: playfairUrl,
  bebas: bebasUrl,
}

const STYLE_ID = 'pulsify-vendored-fonts'

/**
 * Registers the vendored TTFs so the flyer picker previews a typeface in
 * itself. They are the same files the renderer loads, so the preview cannot
 * drift.
 */
export function ensureVendoredFontsLoaded(): void {
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = FLYER_FONTS.map(
    (font) =>
      // Only the variable files carry a weight axis; claiming a range for the
      // static one would stop the browser synthesising a bold it cannot load.
      `@font-face{font-family:"${font.family}";src:url("${FILE_URLS[font.id]}") format("truetype");font-weight:${font.variable ? '100 900' : '400'};font-display:swap;}`,
  ).join('')
  document.head.append(style)
}
